var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconDownloadCloud = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(0.179 -2.13)" },
                React.createElement("path", { d: "M10.5,22.6l4.3,4.3l4.3-4.3" }),
                React.createElement("path", { d: "M14.8,17.1v9.8" }),
                React.createElement("path", { d: "M24.4,23.7c2.4-1.7,3-5.1,1.3-7.5c-1-1.4-2.7-2.3-4.4-2.3H20C18.8,9.3,14,6.5,9.4,7.6\n\t\tS2,13.6,3.2,18.2c0.3,1.3,1,2.6,1.9,3.6" })))));
});
export default IconDownloadCloud;
//# sourceMappingURL=IconDownloadCloud.js.map